// =============================================================================
// components/KpiIncidents/IncidentDashboard.jsx
//
// Layout vertical (tabela em cima, detalhe em baixo collapsible):
//
//   [Header compacto: titulo + ultima atualizacao]
//   [Stat Bar — 5 metricas diferenciadas numa linha]
//   [Distribuicao por KPI — cards com proporcao open/closed]
//   [Filtros — toolbar densa numa linha]
//   [Tabela — barra colorida a esquerda por severidade]
//   [Painel de detalhe — aparece em baixo quando seleciona]
// =============================================================================
import { useEffect } from 'react';
import { Box, Typography, Alert, Stack, Chip, Paper } from '@mui/material';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';

import { useIncidents } from '../../hooks/useKpi';
import IncidentStatBar         from './IncidentStatBar';
import IncidentKpiDistribution from './IncidentKpiDistribution';
import IncidentFilters         from './IncidentFilters';
import IncidentTable           from './IncidentTable';
import IncidentDetailPanel     from './IncidentDetailPanel';

export default function IncidentDashboard() {
	const {
		items, filteredItems, loading, error,
		selected, history, historyLoading,
		filters, totalStats, kpiDistribution,
		availableVendors, availableKpis, availableTechs,
		load, select, updateFilters, clearFilters,
	} = useIncidents();

	useEffect(function () { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

	const handleSelectKpi = function (kpiName) {
		updateFilters({ kpiName: kpiName });
	};

	return (
		<Box sx={{ p: 2.5, bgcolor: '#f7f9fc', minHeight: '100%' }}>

			{/* ========== Header compacto ========== */}
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
				<Box sx={{
					width: 36, height: 36, borderRadius: 1,
					bgcolor: 'primary.main', color: 'white',
					display: 'flex', alignItems: 'center', justifyContent: 'center',
				}}>
					<SignalCellularAltIcon fontSize="small" />
				</Box>
				<Box sx={{ flex: 1 }}>
					<Typography variant="h6" fontWeight={700} sx={{ lineHeight: 1.2, fontSize: '1.05rem' }}>
						KPI Monitor — Incidentes
					</Typography>
					<Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.72rem' }}>
						Detecao de anomalias · Dados D-1 · {items.length.toLocaleString('pt-PT')} incidentes carregados
					</Typography>
				</Box>
				{filteredItems.length !== items.length && (
					<Chip
						label={filteredItems.length.toLocaleString('pt-PT') + ' apos filtros'}
						size="small"
						color="primary"
						variant="outlined"
						sx={{ height: 24, fontSize: '0.72rem' }}
					/>
				)}
			</Box>

			{error && (
				<Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
			)}

			<Stack spacing={1.5}>

				{/* ========== Stat Bar ========== */}
				{/* <IncidentStatBar
					items={items}
					totalStats={totalStats}
					kpiDistribution={kpiDistribution}
					availableVendors={availableVendors}
				/> */}

				{/* ========== Distribuicao por KPI ========== */}
				{/* <IncidentKpiDistribution
					distribution={kpiDistribution}
					selectedKpiName={filters.kpiName}
					onSelectKpi={handleSelectKpi}
				/> */}

				{/* ========== Filtros ========== */}
				<IncidentFilters
					filters={filters}
					availableTechs={availableTechs}
					availableVendors={availableVendors}
					availableKpis={availableKpis}
					onChange={updateFilters}
					onReset={clearFilters}
					onRefresh={load}
					loading={loading}
				/>

				{/* ========== Detalhe (collapsible em baixo) ========== */}
				<IncidentDetailPanel
					incident={selected}
					history={history}
					loading={historyLoading}
					onClose={function () { select(null); }}
				/>

				{/* ========== Tabela ========== */}
				<Paper variant="outlined" sx={{ overflow: 'hidden' }}>
					<IncidentTable
						rows={filteredItems}
						loading={loading}
						selectedId={selected ? selected.incidentId : null}
						onRowClick={select}
					/>
				</Paper>
			</Stack>
		</Box>
	);
}
